import { LoaderCircle, X } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useSiteBranding } from "@/context/SiteContext";
import { api } from "@/lib/api";

const initialForm = { name: "", phone: "", email: "" };

export const BrochureModal = ({ listing, onClose, open }) => {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const { requestParams } = useSiteBranding();

  useEffect(() => {
    if (!open) setForm(initialForm);
  }, [open]);

  if (!open || !listing) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await api.post(`/listings/${listing.id}/brochure-lead`, { ...form, lead_source: "brochure" }, { params: requestParams });
      toast.success("Brochure unlocked successfully");
      window.open(response.data.brochure_url, "_blank", "noopener,noreferrer");
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Unable to unlock brochure right now");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/75 px-4 py-8 backdrop-blur-sm" data-testid="brochure-modal-overlay">
      <div className="luxury-panel w-full max-w-lg p-6 md:p-8" data-testid="brochure-modal-panel">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <p className="subtle-label">Lead-Gated Brochure</p>
            <h3 className="mt-2 text-3xl font-semibold text-white" data-testid="brochure-modal-title">
              Unlock {listing.title}
            </h3>
            <p className="mt-2 text-sm leading-7 text-slate-300">
              Share your details to unlock the brochure pack or official launch page instantly. Your enquiry will be saved to the leads dashboard.
            </p>
          </div>
          <button className="rounded-full border border-white/10 bg-white/5 p-3 text-white" data-testid="brochure-modal-close-button" onClick={onClose} type="button">
            <X className="h-4 w-4" />
          </button>
        </div>

        <form className="grid gap-4" onSubmit={handleSubmit}>
          <input className="field-shell" data-testid="brochure-name-input" onChange={(event) => setForm({ ...form, name: event.target.value })} placeholder="Full Name" required value={form.name} />
          <input className="field-shell" data-testid="brochure-phone-input" onChange={(event) => setForm({ ...form, phone: event.target.value })} placeholder="Phone Number" required value={form.phone} />
          <input className="field-shell" data-testid="brochure-email-input" onChange={(event) => setForm({ ...form, email: event.target.value })} placeholder="Email Address" required type="email" value={form.email} />
          <button className="gold-button w-full" data-testid="brochure-submit-button" disabled={loading} type="submit">
            {loading ? <LoaderCircle className="mr-2 h-4 w-4 animate-spin" /> : null}
            Download Brochure
          </button>
        </form>
      </div>
    </div>
  );
};